import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const BeforeBiddingPartial = ({ title = '', texts = [] }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <div className="col-15 mb-30">
      <div className="row align-items-center">
        <i className="fa-solid fa-exclamation-circle fs-30" />
        <div className="line" style={{ height }} />
        <div className="content-container" ref={ref}>
          <h2 className="content-header">{title}</h2>
          {
            _.map(texts, (text) => (
              <p>{text}</p>
            ))
          }
        </div>
      </div>
    </div>
  );
};

BeforeBiddingPartial.propTypes = {
  title: PropTypes.string,
  texts: PropTypes.array,
};

export default BeforeBiddingPartial;
